<template>
  <div>
    <p class="bold">ארעה שגיאה בשינוי הסטטוס, אנא שנה/י את הסטטוס של ה- Offer ידנית ועדכנ/י את עמית:</p>
    <offer-status :payload="payload.offer"></offer-status>
  </div>
</template>
<script>
import OfferStatus from '@/components/OfferStatus'
export default {
  name: 'cv-offer-status-error-form',
  props: ['payload'],
  components: {
    OfferStatus
  }
}
</script>
